import axios from "axios";
import configData from "../config.json";
import { convertToDate } from "../common/SupportingMethods";
import { getUserId } from "../common/GetUserData";
import { HandleLogout } from "../common/Logout";

const abortController = new AbortController();

export const instance = axios.create({
  baseURL: process.env.REACT_APP_BASEURL,
  headers: {
    "Content-Type": "application/json",
    Authorization: process.env.REACT_APP_TOKEN,
  },
  signal: abortController.signal,
  // withCredentials: true,
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      HandleLogout();
    }
    if (error.response.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;
      await refreshAccessToken();
      return instance(originalRequest);
    }

    return Promise.reject(error);
  }
);

const refreshAccessToken = async () => {
  const res = await instance.post("getrefreshtoken");
};

export const GetBimaps = async (ROLEID, SUBSCRIBERID) => {
  try {
    const response = await instance.get(configData.GETBITMAPS, {
      params: {
        ROLEID: ROLEID,
        SUBSCRIBER_ID: SUBSCRIBERID,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const ApproveBitmap = async (data) => {
  try {
    const response = await instance.post(configData.UPDATEBITMAP, data);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const CreateBitmap = async (data) => {
  try {
    const response = await instance.post(configData.GenerateBitmap, data);

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const GetChannelWiseReport = async (
  ReqFromDate,
  ReqToDate,
  SubscriberId
) => {
  try {
    const response = await instance.get(configData.CHANNELWISEREPORT, {
      params: {
        FROMDATE: convertToDate(ReqFromDate),
        TODATE: convertToDate(ReqToDate),
        SUBSCRIBERID: SubscriberId,
      },
    });
    return response.data;
  } catch (exception) {
    console.error(exception);
  }
};

export const GetOperatorWiseReport = async (
  ReqFromDate,
  ReqToDate,
  SubscriberId
) => {
  try {
    const response = await instance.get(configData.OPERATORWISEREPORT, {
      params: {
        FROMDATE: convertToDate(ReqFromDate),
        TODATE: convertToDate(ReqToDate),
        SUBSCRIBERID: SubscriberId,
      },
    });
    return response.data;
  } catch (exception) {
    console.error(exception);
  }
};

export const GetMessageCodeWiseReport = async (
  ReqFromDate,
  ReqToDate,
  SubscriberId
) => {
  try {
    const response = await instance.get(configData.MESSAGECODEWISEREPORT, {
      params: {
        FROMDATE: convertToDate(ReqFromDate),
        TODATE: convertToDate(ReqToDate),
        SUBSCRIBERID: SubscriberId,
      },
    });
    return response.data;
  } catch (exception) {
    console.error(exception);
  }
};

export const GetChannelWiseDailyReport = async (reqMonth, SubscriberId) => {
  try {
    const response = await instance.get(configData.CHANNELWISEDAILYREPORT, {
      params: {
        SUBSCRIBERID: SubscriberId,
        currentDate: convertToDate(reqMonth),
      },
    });
    return response.data;
  } catch (exception) {
    console.error(exception);
  }
};

export const GetPortalBlockedNumbers = async (MOBILE_NO, STATUSID) => {
  try {
    const response = await instance.get(configData.GETPORTALBLOCKEDNUMBER, {
      params: {
        MOBILENO: MOBILE_NO,
        STATUSID: STATUSID,
      },
    });
    return response.data;
  } catch (exception) {
    console.error(exception);
  }
};

export const DeletePortalBlockedNumberAPI = async (ID) => {
  try {
    const req = {
      ID: ID,
      USERID: getUserId(),
      TYPE: "D",
      COMPANYID: 1,
    };
    const response = await instance.post(
      configData.UPDATEPORTALBLOCKEDNUMBER,
      req
    );
    return response.data;
  } catch (exception) {
    console.error(exception);
  }
};

export const EditPortalBlockedNumberAPI = async (ID, MOBILENO, DESCRIPTION) => {
  try {
    const req = {
      ID: ID,
      MOBILENO: MOBILENO,
      DESCRIPTION: DESCRIPTION,
      USERID: getUserId(),
      COMPANYID: 1,
      TYPE: "E",
    };
    const response = await instance.post(
      configData.UPDATEPORTALBLOCKEDNUMBER,
      req
    );
    return response.data;
  } catch (exception) {
    console.error(exception);
  }
};

export const CreatePortalBlockedNumberAPI = async (MOBILENO, DESCRIPTION) => {
  try {
    const req = {
      MOBILENO: MOBILENO,
      DESCRIPTION: DESCRIPTION,
      USERID: getUserId(),
      COMPANYID: 1,
    };
    const response = await instance.post(
      configData.CREATEPORTALBLOCKEDNUMBER,
      req
    );
    return response.data;
  } catch (exception) {
    console.error(exception);
  }
};

export const GETAPICALL = async (url, reqObject) => {
  try {
    const res = await instance.get(url, { params: reqObject });
    return res.data;
  } catch (exception) {
    console.log("Exception Occured GET " + url + " " + exception);
  }
};

export const POSTAPICALL = async (url, reqObject) => {
  try {
    const res = await instance.post(url, reqObject);
    return res.data;
  } catch (exception) {
    console.log("Exception Occured POST " + url + exception);
  }
};


export const getMSGCODES = async (SUBSCRIBERID) => {
  try {
    const response = await instance.get(configData.GETMSGCODES, {
      params: {
        subscriberId: SUBSCRIBERID,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    console.log("not fetched");
    
  }
};

export const GetSqsStatus = async () => {
  try {
    const response = await instance.get(configData.GETSQSSTATUS);
    return response.data;
  } catch (error) {
    console.error("not fetched");
  }
}

export const GetMsgTemplates = async (ISOTP , SUBSCRIBER) => {
  try {
    const response = await instance.get(configData.GETMSGTEMPLATES, {
      params: {
        isOtp: ISOTP,
        subscriber: SUBSCRIBER,
      },
    });
    return response.data;
  } catch (error) {
    console.error("not fetched");
  }
}

export const GetSubscribers = async () => {
  try {
    const response = await instance.get(configData.GETSUBSCRIBERS);    
    return response.data;
  } catch (error) {
    console.error("not fetched");
  }
}

export const GetRegisteredTemplates = async (SUBSCRIBER) => {
  try {
    const response = await instance.get(configData.GETREGISTEREDTEMPLATE,{
      params: {
        subscriberId : SUBSCRIBER,
      }
    });
    return response.data;
  } catch (error) {
    console.error("not fetched");
  }
}

export const GetUsers = async () => {
  try {
    const response = await instance.get(configData.GETUSERS);
    return response.data;
  } catch (error) {
    console.error("not fetched");
  }
}

export const GetUserMenuStatus = async (USERID) => {
  try{
    const response = await instance.get(configData.GETUSERMENUSTATUS,{
      params: {
        userId : USERID,
      }
    });
    return response.data;
  }catch(error){
    console.error("not fetched");
  }
}

export const UpdateUserAccess = async (USERID,MENUID,STATUS) => {
  try{
    const req = {
      USERID : USERID,
      MENUID : MENUID,
      STATUS : STATUS,
    };
    const response = await instance.post(configData.UPDATEUSERDETAILS,req);
    return response.data;
  }catch(error)
  {
    console.error("not fetched");
  }
}

export const GetUserMobileNumber = async (ACCOUNTNO) => {
  try{
    const response = await instance.get(configData.GETUSERMOBILENUMBER,{
      params: {
        AccountNo : ACCOUNTNO,
      }
    });
    return response.data;
  }catch(error){
    console.error("not fetched");
  }
}

export const GetTimelinesCount = async (USERNAME) => {
  try {
    const response = await instance.get(configData.GETTIMELINESCOUNT,{
      params: {
        userName : USERNAME,
      }
    });
    return response.data;
  } catch (error) {
    console.error("not fetched");
  }
}
